<template>
  <div style="display: inline-block">
    <el-button type="info"
               size="mini"
               @click="showDialog">
      <slot></slot>
    </el-button>

    <el-dialog title="操作提示"
               :visible.sync="outerVisible"
               :modal="false">
      <el-dialog
        width="50%"
        title="批量复制更改门店"
        :visible.sync="innerVisible"
        append-to-body>

        <el-tabs v-model="activeName"
                 @tab-click="handleClick">
          <el-tab-pane label="批量列表"
                       name="list">
            <el-input
              type="textarea"
              autosize
              placeholder="格式: 超市名称/ID(回车分隔符)"
              v-model="form.selectMarket"
              :autosize="{ minRows: 4 }">
            </el-input>
          </el-tab-pane>
          <el-tab-pane label="超市"
                       name="market">
            <el-col :span="20">
              <remote-select
                v-model="marketid"
                placeholder="请输入"
                label-key="marketname"
                id-key="id"
                @change="getMarketInfo"
                :queryParams="{status: 1}"
                :query-request="queryMarket">
              </remote-select>
            </el-col>
            <el-col :span="2"
                    :offset="2">
              <el-button type="primary"
                         size="mini"
                         @click="onAddMarket">添加
              </el-button>
            </el-col>
            <el-col style="margin-top: 15px">
              <el-input
                type="textarea"
                autosize
                placeholder="格式: 超市名称/ID(回车分隔符)"
                v-model="form.selectMarket"
                :autosize="{ minRows: 4 }">
              </el-input>
            </el-col>
          </el-tab-pane>
          <el-tab-pane label="区域"
                       name="area">
            <area-search ref="provinces"></area-search>
          </el-tab-pane>
          <el-tab-pane label="全国"
                       name="national">
          </el-tab-pane>
        </el-tabs>
        <br/><br/>
        <el-button type="primary"
                   size="mini"
                   @click="onSubmit">
          提交
        </el-button>
      </el-dialog>

      <div style="margin-bottom: 20px;font-size: larger">
        是否需要更换门店？
      </div>

      <div>
        <el-checkbox v-model="copyConfigSwitch.blacklist"
                     :disabled="copyInfo.blacklist.length === 0">保留任务黑名单：{{ copyConfig.blacklistString }}
        </el-checkbox>
      </div>

      <div>
        <el-checkbox v-model="copyConfigSwitch.whitelist"
                     :disabled="copyInfo.whitelist.length === 0">保留任务白名单：{{ copyConfig.whitelistString }}
        </el-checkbox>
      </div>

      <div>
        <el-checkbox v-model="copyConfigSwitch.blacklisttags"
                     :disabled="copyInfo.blacklisttags.length === 0">保留任务黑名单标签：</el-checkbox>
        <el-select v-model="copyConfig.blacklisttags" multiple
                   :placeholder="copyInfo.blacklisttags.length === 0 ? '无可选择项' : '请选择'"
                   :disabled="copyInfo.blacklisttags.length === 0">
          <el-option
              v-for="item in copyInfo.blacklisttags"
              :key="item.id"
              :label="item.tagname"
              :value="item.id">
          </el-option>
        </el-select>
      </div>

      <div>
        <el-checkbox v-model="copyConfigSwitch.whitelisttags"
                     :disabled="copyInfo.whitelisttags.length === 0" >保留任务白名单标签：</el-checkbox>
        <el-select v-model="copyConfig.whitelisttags" multiple
                   :placeholder="copyInfo.whitelisttags.length === 0 ? '无可选择项' : '请选择'"
                   :disabled="copyInfo.whitelisttags.length === 0">
          <el-option
              v-for="item in copyInfo.whitelisttags"
              :key="item.id"
              :label="item.tagname"
              :value="item.id">
          </el-option>
        </el-select>
      </div>

      <div slot="footer"
           class="dialog-footer">
        <el-button @click="onCopyTask"
                   size="mini">不需要
        </el-button>
        <el-button type="primary"
                   @click="innerVisible = true"
                   size="mini">需要
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import RemoteSelect from '@core/components/RemoteSelect'
import AreaSearch from '@/views/area/components/AreaSearch'

export default {
  components: {AreaSearch, RemoteSelect},
  props: {
    taskid: String,
  },
  data () {
    return {
      copyConfigSwitch: {
        whitelist: true,
        whitelisttags: true,
        blacklist: true,
        blacklisttags: true,
      },
      copyConfig: {
        blacklistString: '',
        whitelistString: '',
        whitelisttags: [],
        blacklisttags: [],
      },
      copyInfo: {
        whitelist: [],
        whitelisttags: [],
        blacklist: [],
        blacklisttags: [],
      },
      outerVisible: false,
      innerVisible: false,
      activeName: 'list',
      market: [],
      marketid: null,
      form: {
        selectMarket: null,
      },
      marketInfo: null,
      selectMarket: null,
    }
  },
  watch: {
    outerVisible (value) {
      if (!value) {
        Object.assign(this.$data, this.$options.data())
      }
    },
  },
  methods: {
    ...request.map([
      'queryMarket',
      'getUserTagTable',
    ]),
    onSubmit () {
      let detail = {
        task_id: this.taskid,
      }
      if (this.activeName === 'list' || this.activeName === 'market') {
        let marketInfo = this.form.selectMarket
        let market = marketInfo.split('\n')
        if (market.length < 1) {
          this.$message.error('请至少输入一个卖场')
          return false
        }

        for (let n = 0; n < market.length; n++) {
          if (!market[n] || market[n] === '') {
            market.splice(n, 1)
          }
        }

        if (market.length === 1) {
          let marketIds = market[0].split('/')
          detail.market_id = marketIds[1]
          detail.market_name = marketIds[0]
          this.copyTaskSumit(detail)
          return false
        }
        detail.market_ids = []
        for (let i = 0; i < market.length; i++) {
          let marketIds = market[i].split('/')
          detail.market_ids.push(marketIds)
        }
        this.batchCopyTaskSumit(detail)
        return false
      } else if (this.activeName === 'area') {
        let provinceInfo = this.$refs.provinces.form
        detail.province_id = provinceInfo.provinceid
        detail.city_id = provinceInfo.cityid
        detail.area_id = provinceInfo.areaid
      } else if (this.activeName === 'national') {
        detail.province_id = -1
      } else {
        this.$message('操作异常，请联系管理员')
        return false
      }
      this.copyTaskSumit(detail)
    },
    onCopyTask () {
      this.outerVisible = false
      let detail = {
        task_id: this.taskid,
      }
      this.copyTaskSumit(detail)
    },
    copyTaskSumit (detail) {
      detail = this.appendCopyConfig(detail)
      return request.alert('copyTask', detail).then((res) => {
        this.$message({
          showClose: true,
          message: '复制任务成功',
          type: 'success',
        })
        this.outerVisible = false
        this.innerVisible = false
        if (this.$refs.provinces) {
          this.$refs.provinces.form = {
            provinceid: null,
            cityid: null,
            areaid: null,
          }
        }
        this.$store.commit('OPEN_LOADING')
        setTimeout(() => {
          this.$emit('search')
          this.$store.commit('CLOSE_LOADING')
        }, 2000)
      })
    },
    batchCopyTaskSumit (detail) {
      detail = this.appendCopyConfig(detail)
      return request.alert('batchCopyTask', detail).then((res) => {
        this.$message({
          showClose: true,
          message: '操作成功，请前往批量任务查看',
          type: 'success',
        })
        this.outerVisible = false
        this.innerVisible = false
        this.$emit('search')
      })
    },

    handleClick (tab, event) {
      this.form.selectMarket = null
    },
    getMarketInfo (detail) {
      if (this.selectMarket) {
        this.selectMarket += '\n' + detail.marketname + '/' + detail.id
      } else {
        this.selectMarket = detail.marketname + '/' + detail.id
      }
    },
    onAddMarket () {
      this.form.selectMarket = this.selectMarket
    },
    showDialog () {
      this.outerVisible = true
      request.common('getCopyTaskInfo', {id: this.taskid}).then(data => {
        this.copyInfo = data.data
        this.copyConfig.whitelisttags = this.copyInfo.whitelisttags.map(function (value) {
          return value.id
        })
        this.copyConfig.blacklisttags = this.copyInfo.blacklisttags.map(function (value) {
          return value.id
        })

        let whitelist = Array.from(this.copyInfo.whitelist)
        let blacklist = Array.from(this.copyInfo.blacklist)

        this.copyConfig.whitelistString = '没有任务白名单'
        this.copyConfig.blacklistString = '没有任务黑名单'

        if (this.copyInfo.whitelist.length) {
          this.copyConfig.whitelistString = whitelist.splice(0, 3).join(',')
          if (this.copyInfo.whitelist.length > 3) {
            this.copyConfig.whitelistString += '......等' + this.copyInfo.whitelist.length + '个'
          }
        }

        if (this.copyInfo.blacklist.length) {
          this.copyConfig.blacklistString = blacklist.splice(0, 3).join(',')
          if (this.copyInfo.blacklist.length > 3) {
            this.copyConfig.blacklistString += '......等' + this.copyInfo.blacklist.length + '个'
          }
        }
      }).catch(error => {
        // 暂时无法复制中台项目下的任务
        if (_.get(error, 'response.data.ret') === 387) {
          this.outerVisible = false
        }
      })
    },
    appendCopyConfig (detail) {
      if (this.copyConfigSwitch.blacklist && this.copyInfo.blacklist) {
        detail.blacklist = this.copyInfo.blacklist
      }

      if (this.copyConfigSwitch.whitelist && this.copyInfo.whitelist) {
        detail.whitelist = this.copyInfo.whitelist
      }

      if (this.copyConfigSwitch.blacklisttags && this.copyConfig.blacklisttags) {
        detail.blacklisttags = this.copyConfig.blacklisttags
      }

      if (this.copyConfigSwitch.whitelisttags && this.copyConfig.whitelisttags) {
        detail.whitelisttags = this.copyConfig.whitelisttags
      }

      return detail
    }
  },
}
</script>




// WEBPACK FOOTER //
// src/views/task/components/buttons/TaskCopyButton.vue